import { render } from "./GrantedActionModal.vue?vue&type=template&id=8c2f97fa&scoped=true"
import script from "./GrantedActionModal.vue?vue&type=script&lang=js"
export * from "./GrantedActionModal.vue?vue&type=script&lang=js"

import "./GrantedActionModal.vue?vue&type=style&index=0&id=8c2f97fa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c2f97fa"]])

export default __exports__